import { FunctionComponent, ReactNode } from 'react'
import styles from './dialog.module.scss'
import MaterialUIDialog from '@mui/material/Dialog'
import { DialogActionsTarget } from '@/components/_custom/DialogActions/DialogActions'
import { DialogHeaderTarget } from '@/components/_custom/DialogHeader/DialogHeader'

interface DialogProps {
    open: boolean
    handleClose?: () => void
    className?: string
    maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl'
    transitionDuration?: number
    transitionEasing?: 'linear' | 'ease' | 'ease-in' | 'ease-out' | 'ease-in-out' | 'step-start' | 'step-end'
    children: ReactNode
}

const Dialog: FunctionComponent<DialogProps> = ({
    open = false,
    handleClose,
    className,
    maxWidth = false,
    children,
    transitionDuration,
    transitionEasing
}: DialogProps) => {
    return (
        <MaterialUIDialog
            open={open}
            onClose={handleClose}
            maxWidth={maxWidth}
            className={className}
            transitionDuration={transitionDuration}
            slotProps={{ transition: { easing: transitionEasing } }}
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: '20px'
                }
            }}
        >
            <DialogActionsTarget.Provider value={{ target: null, renderWrapper: false }}>
                <DialogHeaderTarget.Provider value={null}>
                    <div className={styles.Root}>{children}</div>
                </DialogHeaderTarget.Provider>
            </DialogActionsTarget.Provider>
        </MaterialUIDialog>
    )
}

export default Dialog
